export const getLegacyUrl = (): string | null => {
  const cookie = document.cookie;
  const parts = cookie.split(";");
  const apexURL = parts.find(p => p.includes("apexOnlineURL"));
  if (apexURL) {
    return apexURL.split("URL=")[1];
  }
  return null;
};
